import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const unlinkCharger: UseCase<ChargerRepository, 'unlinkCharger'> = repository => {
  return async (chargerUid) => {
    await repository.unlinkCharger(chargerUid)
  }
}
